import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  fullWidth?: boolean;
  showIcon?: boolean;
}
export function Button({
  children,
  className = '',
  fullWidth = false,
  showIcon = true,
  ...props
}: ButtonProps) {
  return <button className={`
        relative overflow-hidden group
        bg-gradient-to-r from-[#D4AF37] to-[#F5D76E]
        text-[#0A0A0A] font-bold text-lg px-8 py-4 rounded-lg
        shadow-[0_4px_14px_0_rgba(212,175,55,0.39)]
        hover:shadow-[0_6px_20px_rgba(212,175,55,0.23)]
        hover:scale-[1.02] active:scale-[0.98]
        transition-all duration-300 ease-out
        flex items-center justify-center gap-2
        ${fullWidth ? 'w-full' : 'w-auto'}
        ${className}
      `} {...props} data-id="element-200">
      <span className="relative z-10" data-id="element-201">{children}</span>
      {showIcon && <ArrowRight className="w-5 h-5 relative z-10 group-hover:translate-x-1 transition-transform duration-300" data-id="element-202" />}

      {/* Shine effect overlay */}
      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out z-0" data-id="element-203" />
    </button>;
}